import { lazy, Suspense, useEffect } from 'react'

import PreloaderPage from '../../components/UI/PreloaderPage/PreloaderPage'
import { setCSSVariable } from '../../helpers/setVariable'

const ArticlePage20 = lazy(() =>
  import('./ArticlePage20').then(module => ({
    default: module.ArticlePage20,
  }))
)

export default function ArticlePage20Lazy() {
  useEffect(() => {
    setCSSVariable('--body-bg', '#fff')
    return () => setCSSVariable('--body-bg', '#f7f7f5')
  })
  return (
    <Suspense fallback={<PreloaderPage />}>
      <ArticlePage20 />
    </Suspense>
  )
}
